/**
 * ── "CITY, ST" — THE STATE IS NEVER SAID TWICE (2026-10-30, Justin Bradford, SLC email
 * 1041310: the Header read "Brixton Park | Saratoga Springs, UT, UT") ──────────────────
 * The locator line is city + ", " + state. When the city value already ends with that state
 * ("Saratoga Springs, UT", "Saratoga Springs UT"), the state is not added again. A city that
 * merely contains the letters ("Utica") is left alone: the match is the whole last word.
 */
export function echCityState(city: string, state: string): string {
  let c = String(city || "").trim();
  while (c && (c.endsWith(",") || c.endsWith(" "))) c = c.slice(0, -1);
  const st = String(state || "").trim();
  if (!c) return "";
  if (!st) return c;
  const lc = c.toLowerCase(), ls = st.toLowerCase();
  if ([", ", ",", " "].some((sep) => lc.endsWith(sep + ls))) return c;
  return c + ", " + st;
}
